import { MouseEvent, ReactNode, useCallback } from "react";
import { Link, useNavigate } from "react-router";
import { useModulePathResolver } from "./hooks";
import { ReactComponent as DirigibleCrash } from "./assets/404-dirigible.svg";
import { ReactComponent as Ground } from "./assets/ground.svg";
import classNames from "classnames";
import styled from "styled-components";

/** The error page root. */
const ErrorPageRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** The error container. */
const ErrorContainer = styled.div`
`;

/** the error code. */
const ErrorCode = styled.p`
  font-size: 32px;
`;

/** The error message. */
const ErrorMessage = styled.p`
  font-size: 16px;
`;

/** The error background. */
const ErrorBackground = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 520px;
  z-index: -1;
`;

/** The error background image ground. */
const ErrorGround = styled(Ground)`
  width: 100%;
  height: 100%;
`;

/** The `Error404Page` component properties. */
export interface Error404PageProps {

  /** The CSS class name. */
  readonly className?: string;
}

/** A component which displays the content of the 404 error page. */
export const Error404Page = (props: Error404PageProps): ReactNode => {
  const { className } = props;

  const modulePath = useModulePathResolver();
  const navigate = useNavigate();

  const backHandler = useCallback((ev: MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault();
    navigate(-1);
  }, []);

  return (
    <ErrorPageRoot className={classNames("pageNotFound", className)}>
      <ErrorContainer className="errBlock">
        <ErrorCode className="errCode">404</ErrorCode>
        <ErrorMessage className="errMsg">
          Mission failure, this page doesn’t exist!<br />
          Let’s go <a href="#" onClick={backHandler}> back </a> to safety. Or all
          the way <Link to={modulePath("/")}>home</Link>.
        </ErrorMessage>
      </ErrorContainer>
      <DirigibleCrash />
      <ErrorBackground className="background">
        <ErrorGround className="ground" />
      </ErrorBackground>
    </ErrorPageRoot>
  );
};
